import { getHeaders } from "./apiHelper";

async function request(path, { method = "GET", body, signal } = {}) {
  const base = process.env.REACT_APP_API_URL;
  if (!base) throw new Error("The backend API URL is not configured.");
  const root = `${base.replace(/\/$/, "")}/api/v1/notification-tests`;
  const controller = new AbortController();
  const abort = () => controller.abort();
  if (signal) {
    if (signal.aborted) abort();
    else signal.addEventListener("abort", abort);
  }
  const timer = setTimeout(abort, 20000);
  try {
    const response = await fetch(root + path, {
      method,
      headers: getHeaders(false),
      signal: controller.signal,
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    });
    let json;
    try {
      json = await response.json();
    } catch (_) {
      json = null;
    }
    if (!response.ok) {
      const message =
        response.status >= 500
          ? "Notification testing is unavailable. Please try again."
          : json && typeof json.message === "string"
          ? json.message
          : "The request was refused.";
      const error = new Error(
        response.status === 401
          ? "Your web session has expired. Sign out and sign in again."
          : message
      );
      error.status = response.status;
      throw error;
    }
    if (
      !json ||
      json.status !== "success" ||
      !json.data ||
      typeof json.data !== "object"
    )
      throw new Error("The server returned invalid notification test data.");
    return json.data;
  } catch (error) {
    if (signal && signal.aborted) {
      const cancelled = new Error("Request cancelled.");
      cancelled.name = "AbortError";
      throw cancelled;
    }
    if (error.name === "AbortError")
      throw new Error("The request timed out. You can retry sending safely.");
    if (error instanceof TypeError)
      throw new Error(
        "Cannot reach the local backend. Check that it is running."
      );
    throw error;
  } finally {
    clearTimeout(timer);
    if (signal) signal.removeEventListener("abort", abort);
  }
}
export function createNotificationRequestId() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (byte) =>
    byte.toString(16).padStart(2, "0")
  ).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(
    12,
    16
  )}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
export const notificationTestApi = {
  capabilities: () => request("/capabilities"),
  search: (q, signal) =>
    request(`/employees?q=${encodeURIComponent(q)}`, { signal }),
  send: (body) => request("", { method: "POST", body }),
  status: (id) => request(`/${encodeURIComponent(id)}/status`),
};
